var React = require('react');
var { useState, useEffect } = require('react');
var $ = require('jquery');
var { Document, Page, pdfjs } = require('react-pdf');
var { trackPageView } = require('Utils');

// Set up PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const TermsAndConditions = (props) => {
  const [numPagesEnglish, setNumPagesEnglish] = useState(null);
  const [numPagesHebrew, setNumPagesHebrew] = useState(null);

  useEffect(() => {
    // Track when the modal is shown
    const modalId = props.modalId || 'termsAndConditionsId';
    $(`#${modalId}`).on('shown.bs.modal', () => {
      trackPageView('Terms and Conditions');
    });

    return () => {
      $(`#${modalId}`).off('shown.bs.modal');
    };
  }, [props.modalId]);

  const onDocumentLoadSuccessEnglish = ({ numPages }) => {
    setNumPagesEnglish(numPages);
  };

  const onDocumentLoadSuccessHebrew = ({ numPages }) => {
    setNumPagesHebrew(numPages);
  };

  return (
    <>
      <style>{`
          .react-pdf__Document {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .react-pdf__Page {
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            margin-bottom: 1rem;
          }
          .react-pdf__Page__canvas {
            max-width: 100%;
            height: auto !important;
          }
        `}</style>
      <div
        className='modal fade mt-5 mb-5 pt-3 pb-5'
        id='termsAndConditionsId'
        tabIndex='-1'
        role='dialog'
        aria-labelledby='exampleModalLabel'
        aria-hidden='true'
      >
        <div
          className='modal-dialog modal-lg modal-dialog-centered'
          role='document'
        >
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title' id='exampleModalLabel'>
                Terms and Conditions
              </h5>
              <button
                type='button'
                className='close'
                data-dismiss='modal'
                aria-label='Close'
              >
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <div className='modal-body'>
              <div className='overflow-auto' style={{ height: '600px' }}>
                <ul className='nav nav-tabs' id='myTab' role='tablist'>
                  <li className='nav-item'>
                    <a
                      className='nav-link active'
                      id='home-tab'
                      data-toggle='tab'
                      href='#home'
                      role='tab'
                      aria-controls='home'
                      aria-selected='true'
                    >
                      English
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      id='profile-tab'
                      data-toggle='tab'
                      href='#profile'
                      role='tab'
                      aria-controls='profile'
                      aria-selected='false'
                    >
                      עברית
                    </a>
                  </li>
                </ul>

                <div className='tab-content' id='myTabContent'>
                  <div
                    className='tab-pane fade show active'
                    id='home'
                    role='tabpanel'
                    aria-labelledby='home-tab'
                  >
                    <div
                      className='w-100 p-3'
                      style={{
                        border: '1px solid #dfe7f0',
                        borderTop: '0px solid #dfe7f0',
                        backgroundColor: 'white',
                      }}
                    >
                      <Document
                        file={require('updatedTNC')}
                        onLoadSuccess={onDocumentLoadSuccessEnglish}
                        loading={
                          <div className='text-center p-5'>Loading...</div>
                        }
                      >
                        {numPagesEnglish &&
                          Array.from(
                            new Array(numPagesEnglish),
                            (el, index) => (
                              <Page
                                key={`page_${index + 1}`}
                                pageNumber={index + 1}
                                width={800}
                                renderTextLayer={false}
                                renderAnnotationLayer={false}
                                className='mb-3'
                              />
                            ),
                          )}
                      </Document>
                    </div>
                  </div>
                  <div
                    className='tab-pane fade'
                    id='profile'
                    role='tabpanel'
                    aria-labelledby='profile-tab'
                  >
                    <div
                      className='w-100 p-3'
                      style={{
                        border: '1px solid #dfe7f0',
                        borderTop: '0px solid #dfe7f0',
                        backgroundColor: 'white',
                      }}
                    >
                      <Document
                        file={require('HebrewTNC')}
                        onLoadSuccess={onDocumentLoadSuccessHebrew}
                        loading={
                          <div className='text-center p-5'>Loading...</div>
                        }
                      >
                        {numPagesHebrew &&
                          Array.from(new Array(numPagesHebrew), (el, index) => (
                            <Page
                              key={`page_${index + 1}`}
                              pageNumber={index + 1}
                              width={800}
                              renderTextLayer={false}
                              renderAnnotationLayer={false}
                              className='mb-3'
                            />
                          ))}
                      </Document>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

module.exports = TermsAndConditions;
